let qiuzhi = [
	//1
	{
		avatar: "http://image.hudiejx.com/jobWanted/20210608/4b609023c950498b8def7c268d33a77d.jpeg",
		birthday: "1990-08-09",
		brandId: 174,
		brandName: null,
		cityCode: 510121,
		contactPerson: "兰先生",
		contactStatus: "离职,随时上岗",
		contactTel: "1994324958",
		createTime: "2021-06-08",
		districtCode: 5101,
		education: "中专",
		id: 46,
		isFaceToFace: 1,
		isOwn: null,
		machineId: 4,
		machineName: null,
		provinceCode: 51,
		remark: "会点维修知识",
		salaryMax: 7000,
		salaryMin: 7000,
		sort: 0,
		status: 1,
		title: "操作机手",
		updateTime: "2021-06-09 11:27:51",
		userId: 4365,
		workExperienceCode: 2,
		workExperienceStr: "3年及以上",
		workPlace: "四川省成都市金堂县",
	},
	//2
	{
		avatar: "http://image.hudiejx.com/jobWanted/20210608/f8bbd7e638f4405ca96f28ec9e33564c.jpeg",
		birthday: "1987-09-13",
		brandId: 177,
		brandName: null,
		cityCode: 350582,
		contactPerson: "许先生",
		contactStatus: "在职,考虑近期换工作",
		contactTel: "18977465498",
		createTime: "2021-06-08",
		districtCode: 3505,
		education: "中专",
		id: 45,
		isFaceToFace: 1,
		isOwn: null,
		machineId: 4,
		machineName: null,
		provinceCode: 35,
		remark: "大小挖机都可以开。",
		salaryMax: 11000,
		salaryMin: 9000,
		sort: 0,
		status: 1,
		title: "大小挖机机手",
		updateTime: "2021-06-08 17:09:16",
		userId: 4365,
		workExperienceCode: 2,
		workExperienceStr: "3年及以上",
		workPlace: "福建省泉州市晋江市",
	},
	//3
	{
		avatar: "http://image.hudiejx.com/jobWanted/20210608/34cce4aeb1974209811c48ea11731b8c.jpeg",
		birthday: "1989-08-11",
		brandId: 174,
		brandName: null,
		cityCode: 511703,
		contactPerson: "唐先生",
		contactStatus: "离职,随时上岗",
		contactTel: "19942215788",
		createTime: "2021-06-08",
		districtCode: 5117,
		education: "初中",
		id: 44,
		isFaceToFace: 1,
		isOwn: null,
		machineId: 3,
		machineName: null,
		provinceCode: 51,
		remark: "有五年以上工作经验",
		salaryMax: 12000,
		salaryMin: 8000,
		sort: 0,
		status: 1,
		title: "操作机手",
		updateTime: "2021-06-09 16:03:30",
		userId: 4365,
		workExperienceCode: 3,
		workExperienceStr: "5年及以上",
		workPlace: "四川省达州市达川区",
	},
	//4
	{
		avatar: "http://image.hudiejx.com/jobWanted/20210608/d2383f00c38941f684295832fb82609c.jpeg",
		birthday: "1993-06-08",
		brandId: 174,
		brandName: null,
		cityCode: 513429,
		contactPerson: "肖先生",
		contactStatus: "离职,随时上岗",
		contactTel: "13347247889",
		createTime: "2021-06-08",
		districtCode: 5134,
		education: "初中",
		id: 43,
		isFaceToFace: 1,
		isOwn: null,
		machineId: 3,
		machineName: null,
		provinceCode: 51,
		remark: "其他都还可以，工资月结都可以",
		salaryMax: 7000,
		salaryMin: 5000,
		sort: 0,
		status: 1,
		title: "旋挖机手",
		updateTime: "2021-06-08 17:09:22",
		userId: 4365,
		workExperienceCode: 0,
		workExperienceStr: "1年及以上",
		workPlace: "四川省凉山彝族自治州布拖县",
	},
	//5
	{
		avatar: "http://image.hudiejx.com/jobWanted/20210608/d7c6bd47476b4c5b9fc7edfff1fbaafa.jpeg",
		birthday: "1991-08-12",
		brandId: 177,
		brandName: null,
		cityCode: 450803,
		contactPerson: "甘先生",
		contactStatus: "离职,随时上岗",
		contactTel: "15211462278",
		createTime: "2021-06-08",
		districtCode: 4508,
		education: "大专",
		id: 42,
		isFaceToFace: 1,
		isOwn: null,
		machineId: 7,
		machineName: null,
		provinceCode: 45,
		remark: "会装车，会拽土，会挖沟，长期干",
		salaryMax: 5000,
		salaryMin: 4000,
		sort: 0,
		status: 1,
		title: "挖掘机手",
		updateTime: "2021-06-10 10:07:49",
		userId: 4365,
		workExperienceCode: 1,
		workExperienceStr: "2年及以上",
		workPlace: "广西壮族自治区贵港市港南区",
	},
	//6
	{
		avatar: "http://image.hudiejx.com/jobWanted/20210608/08ff9e2bfca047f698541ce8c2ff9f65.jpeg",
		birthday: "1991-09-24",
		brandId: 211,
		brandName: null,
		cityCode: 451029,
		contactPerson: "李先生",
		contactStatus: "离职,随时上岗",
		contactTel: "18983214577",
		createTime: "2021-06-08",
		districtCode: 4510,
		education: "中专",
		id: 41,
		isFaceToFace: 1,
		isOwn: null,
		machineId: 3,
		machineName: null,
		provinceCode: 45,
		remark: "要求不高",
		salaryMax: 6000,
		salaryMin: 5000,
		sort: 0,
		status: 1,
		title: "旋挖机手",
		updateTime: "2021-06-08 16:11:50",
		userId: 4365,
		workExperienceCode: 0,
		workExperienceStr: "1年及以上",
		workPlace: "广西壮族自治区百色市田林县",
	},
	//7
	{
		avatar: "http://image.hudiejx.com/jobWanted/20210608/c6c74c99d4f646e3a7d5a7227ed42b82.jpeg",
		birthday: "1989-09-15",
		brandId: 174,
		brandName: null,
		cityCode: 500236,
		contactPerson: "高先生",
		contactStatus: "离职,随时上岗",
		contactTel: "17782304597",
		createTime: "2021-06-08",
		districtCode: 5002,
		education: "中专",
		id: 40,
		isFaceToFace: 1,
		isOwn: null,
		machineId: 3,
		machineName: null,
		provinceCode: 50,
		remark: "吃苦耐劳",
		salaryMax: 8000,
		salaryMin: 7000,
		sort: 0,
		status: 1,
		title: "旋挖机手",
		updateTime: "2021-06-10 13:59:25",
		userId: 4365,
		workExperienceCode: 2,
		workExperienceStr: "3年及以上",
		workPlace: "重庆市县奉节县",
	},
]

module.exports = {
	qiuzhi: qiuzhi
}
